import React from "react";
import StyledSelect from "./styled/StyledSelect";

const Select = React.memo(({ children, meta,  ...props }) => {
  return <StyledSelect  {...meta} value={props.value} {...props} >{children}</StyledSelect>;
});

export default Select;
